/**
 * 工资管理 API
 */
import Ajax from '../js/common/ajax';

export default {
	// 获取工资单列表
	getSalaries() {
		return Ajax.get("/salaries")
	},
	// 获取单个工资单
	getSalary(id) {
		return Ajax.get(`/salaries/${id}`)
	},
	// 获取统计
	getSalaryStatistics() {
		return Ajax.get("/salaries/statistics")
	},
	// 创建工资单
	createSalary(params = {}) {
		return Ajax.post("/salaries", params)
	},
	// 更新工资单
	updateSalary(id, params = {}) {
		return Ajax.put(`/salaries/${id}`, params)
	},
	// 删除工资单
	deleteSalary(id) {
		return Ajax.delete(`/salaries/${id}`)
	},
	// 发放工资
	paySalary(id) {
		return Ajax.post(`/salaries/${id}/pay`)
	}
}
